import script from "./BrandedCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandedCard.vue?vue&type=script&setup=true&lang=js"

import "./BrandedCard.vue?vue&type=style&index=0&id=4427a09c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4427a09c"]])

export default __exports__